import { Container } from "@pixi/display";
import { FigureData } from "../../../models/figure/FigureData";
import { SquareView } from "../square/SquareView";

export class BaseFigureView extends Container {

    public constructor(
        protected readonly figureData: FigureData,
        protected readonly squares: Array<SquareView>
    ) {
        super();
        this.drawFigure();
    }

    protected drawFigure(): void {
        for (let i = 0; i < this.squares.length; i++) {
            const squaresInRow = this.figureData.width;
            const squareSize = this.squares[i].width;
            const square = this.squares[i];
            const row = Math.floor(i / squaresInRow);
            const col = i % squaresInRow;
            square.x = col * squareSize;
            square.y = row * squareSize;
            this.addChild(square);
        }
    }
}
